import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import 'sortablejs';
import 'js-cookie';
import './modules/cms-datepicker';
import './modules/cms-select2';
import '@fancyapps/fancybox';
import 'jquery.scrollto';

window.ajaxPaging = function(obj, target) {
    if(obj.data('disabled')) {
        return false;
    }
    obj.data('disabled', true);

    var link = obj.data('href') || obj.attr('href');

    $(target).load(link, function(){
        obj.data('disabled', false);

        if($(target).length) {
            $.scrollTo($(target));
            $(target).trigger('after-reload');
        }
    });

    return false;
};

window.submitOrderingForm = function(field) {
    var jContainer = $(field).closest('.ordering_form_wrap');
    var order = jContainer.find('select[name="order"]').val();
    var dir = jContainer.find('select[name="direction"]').val();

    if(order && dir) {
        jContainer.find('input[name="ordering"]').val(order + '.' + dir);
        jContainer.find('form').submit();
    }
};

window.scrollToTarget = function(jTarget, delay) {
    if(parseInt(delay)) {
        setTimeout(function(){
            $.scrollTo(jTarget);
        }, parseInt(delay));
    } else {
        $.scrollTo(jTarget);
    }
};